//Feature Tray Local Storage
jQuery(document).ready(function () {
  if (sessionStorage.getItem('traySeen') != 'shown') {
    jQuery('#featureTray').addClass('open')

  }
  jQuery('button.close-tray').click(function () {
    jQuery('#featureTray').removeClass('open')
    sessionStorage.setItem('traySeen', 'shown')
  })
  jQuery('a.open-tray').click(function () {
    jQuery('#featureTray').addClass('open')
  })
})

jQuery(document).ready(function () {
  jQuery('#user_login').attr('placeholder', 'Email Address')
  jQuery('#user_email').attr('placeholder', 'Email Address')
  jQuery('#user_pass').attr('placeholder', 'Password')
})

jQuery('.ui_ship_name').addClass("gfield_visibility_hidden")
jQuery('.ui_ship_attn').addClass("gfield_visibility_hidden")
jQuery('.ui_ship_addr1').addClass("gfield_visibility_hidden")
jQuery('.ui_ship_addr2').addClass("gfield_visibility_hidden")
jQuery('.ui_ship_city').addClass("gfield_visibility_hidden")
jQuery('.ui_ship_state').addClass("gfield_visibility_hidden")
jQuery('.ui_ship_postal').addClass("gfield_visibility_hidden")
jQuery('.ui_ship_country').addClass("gfield_visibility_hidden")
jQuery('.ui_ship_country_multi').addClass("gfield_visibility_hidden")
jQuery(document).on('change', '.ui_addr_select select', function (e) {
  var value = jQuery(this).val()

  if (value == '1') {
    jQuery('.ui_ship_addr1 input').val("5 Rue Charlot")
    jQuery('.ui_ship_addr2 input').val("")
    jQuery('.ui_ship_city input').val("Paris")
    jQuery('.ui_ship_state input').val("")
    jQuery('.ui_ship_postal input').val("")
    jQuery('.ui_ship_country select').val("_france")
    jQuery('.ui_ship_country_multi input').val("France")
  };
  if (value == '2') {
    jQuery('.ui_ship_addr1 input').val("Mr Treublaan 7")
    jQuery('.ui_ship_addr2 input').val("")
    jQuery('.ui_ship_city input').val("Amsterdam")
    jQuery('.ui_ship_state input').val("")
    jQuery('.ui_ship_postal input').val("")
    jQuery('.ui_ship_country select').val("_netherlands")
    jQuery('.ui_ship_country_multi input').val("Netherlands")
  };
  if (value == '3') {
    jQuery('.ui_ship_addr1 input').val("47 Thomas St")
    jQuery('.ui_ship_addr2 input').val("")
    jQuery('.ui_ship_city input').val("Limerick")
    jQuery('.ui_ship_state input').val("")
    jQuery('.ui_ship_postal input').val("")
    jQuery('.ui_ship_country select').val("_ireland")
    jQuery('.ui_ship_country_multi input').val("Ireland")

  };
  if (value == '4') {
    jQuery('.ui_ship_addr1 input').val("2 Leman Street")
    jQuery('.ui_ship_addr2 input').val("")
    jQuery('.ui_ship_city input').val("London")
    jQuery('.ui_ship_state input').val("")
    jQuery('.ui_ship_postal input').val("")
    jQuery('.ui_ship_country select').val("_unitedKingdom")
    jQuery('.ui_ship_country_multi input').val("United Kingdom")
  };
  if (value == '5') {
    jQuery('.ui_ship_addr1 input').val("Av. Barbosa du Bocage 85")
    jQuery('.ui_ship_addr2 input').val("")
    jQuery('.ui_ship_city input').val("Lisboa")
    jQuery('.ui_ship_state input').val("")
    jQuery('.ui_ship_postal input').val("1050-030")
    jQuery('.ui_ship_country select').val("_portugal")
    jQuery('.ui_ship_country_multi input').val("Portugal")
  };
  if (value == '6') {
    jQuery('.ui_ship_addr1 input').val("Lubicz str. 17G")
    jQuery('.ui_ship_addr2 input').val("2nd floor")
    jQuery('.ui_ship_city input').val("Krakow")
    jQuery('.ui_ship_state input').val("")
    jQuery('.ui_ship_postal input').val("31-503")
    jQuery('.ui_ship_country select').val("_poland")
    jQuery('.ui_ship_country_multi input').val("Poland")
  };
  if (value == '7') {
    jQuery('.ui_ship_name').val("")
    jQuery('.ui_ship_attn').val("")
    jQuery('.ui_ship_addr1 input').val("")
    jQuery('.ui_ship_addr2 input').val("")
    jQuery('.ui_ship_city input').val("")
    jQuery('.ui_ship_state input').val("")
    jQuery('.ui_ship_postal input').val("")
    jQuery('.ui_ship_country select').val("")
    jQuery('.ui_ship_country_multi input').val("")
    jQuery('.ui_ship_name').removeClass("gfield_visibility_hidden")
    jQuery('.ui_ship_attn').removeClass("gfield_visibility_hidden")
    jQuery('.ui_ship_addr1').removeClass("gfield_visibility_hidden")
    jQuery('.ui_ship_addr2').removeClass("gfield_visibility_hidden")
    jQuery('.ui_ship_city').removeClass("gfield_visibility_hidden")
    jQuery('.ui_ship_state').removeClass("gfield_visibility_hidden")
    jQuery('.ui_ship_postal').removeClass("gfield_visibility_hidden")
    jQuery('.ui_ship_country').removeClass("gfield_visibility_hidden")
    jQuery('.ui_ship_country_multi').removeClass("gfield_visibility_hidden")
  };
  if (value != '7') {
    jQuery('.ui_ship_name').addClass("gfield_visibility_hidden")
    jQuery('.ui_ship_attn').addClass("gfield_visibility_hidden")
    jQuery('.ui_ship_addr1').addClass("gfield_visibility_hidden")
    jQuery('.ui_ship_addr2').addClass("gfield_visibility_hidden")
    jQuery('.ui_ship_city').addClass("gfield_visibility_hidden")
    jQuery('.ui_ship_state').addClass("gfield_visibility_hidden")
    jQuery('.ui_ship_postal').addClass("gfield_visibility_hidden")
    jQuery('.ui_ship_country').addClass("gfield_visibility_hidden")
    jQuery('.ui_ship_country_multi').addClass("gfield_visibility_hidden")
  }
})

jQuery('.ui_multi_list .gfield_list_50_cell7').addClass('gfield_visibility_hidden')
jQuery('.ui_multi_list .gfield_list_50_cell7 input').val('Silver')
jQuery('.ui_multi_list .gfield_header_item:nth-of-type(7)').addClass('gfield_visibility_hidden');

//Jquery element animations on scroll

(function ($) {

  /**
   * Copyright 2012, Digital Fusion
   * Licensed under the MIT license.
   * http://teamdf.com/jquery-plugins/license/
   *
   * @author Sam Sehnert
   * @desc A small plugin that checks whether elements are within
   *     the user visible viewport of a web browser.
   *     only accounts for vertical position, not horizontal.
   */

  $.fn.visible = function (partial) {

    var $t = $(this),
      $w = $(window),
      viewTop = $w.scrollTop(),
      viewBottom = viewTop + $w.height(),
      _top = $t.offset().top,
      _bottom = _top + $t.height(),
      compareTop = partial === true ? _bottom : _top,
      compareBottom = partial === true ? _top : _bottom

    return ((compareBottom <= viewBottom) && (compareTop >= viewTop))

  }

})(jQuery);


(function () {
  const patchRecaptchaRender = () => {
    if (typeof grecaptcha === 'undefined' || !grecaptcha.render || grecaptcha.__patched) return

    const originalRender = grecaptcha.render

    grecaptcha.render = function (container, parameters) {
      // Get the actual DOM element (could be an ID or an element)
      const el = typeof container === 'string' ? document.getElementById(container) : container

      // Check if it's already rendered
      if (el && el.querySelector('.grecaptcha-badge, div div')) {
        console.warn('grecaptcha.render skipped: already rendered on element', el)
        return null // skip rendering
      }

      return originalRender.call(this, container, parameters)
    }

    grecaptcha.__patched = true
    console.info('grecaptcha.render has been patched to prevent double rendering.')
  }

  // Try immediately, or retry until grecaptcha is available
  const waitForGrecaptcha = setInterval(() => {
    if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.render === 'function') {
      clearInterval(waitForGrecaptcha)
      patchRecaptchaRender()
    }
  }, 100)
})();

(function ($) {
  "use strict"

  function scaleCaptcha() {
    var reCaptchaWidth = 304

    $('.ginput_recaptcha').each(function () {
      var $container = $(this)
      var $captcha = $container.find('div').first() // Or adjust if needed
      var containerWidth = $container.width()

      console.log('Scaling CAPTCHA in:', $container.attr('id'))
      console.log('Container width:', containerWidth)

      if (containerWidth && reCaptchaWidth > containerWidth) {
        var captchaScale = containerWidth / reCaptchaWidth

        console.log('Applying scale:', captchaScale)

        $captcha.css({
          'transform': 'scale(' + captchaScale + ')',
          'transform-origin': '0 0'
        })
      } else {
        console.log('No scaling needed or container too wide. Resetting.')

        $captcha.css({
          'transform': '',
          'transform-origin': ''
        })
      }
    })
  }

  $(window).on('load resize', function () {
    setTimeout(scaleCaptcha, 100) // Let reCAPTCHA render first
  })
})(jQuery);

// (function ($) {
//   function setBottomPadding() {
//     var $bgImage = $('.text-feature-image .grid-x:first-of-type')
//     var $target = $bgImage
//     var $ctaBgImage = $('.cta-block .bg-img')
//     var $ctaTarget = $('.cta-block')

//     if ($bgImage.length && $target.length) {
//       var bgHeight = $bgImage.outerHeight(true)
//       $target.css('padding-bottom', bgHeight - 40 + 'px')
//     }
//     if ($ctaBgImage.length && $ctaTarget.length) {
//       var bgHeight = $ctaBgImage.outerHeight(true)
//       $ctaTarget.css('padding-bottom', bgHeight + 40 + 'px')
//     }
//   }

//   function maybeSetPadding() {
//     if (window.innerWidth < 1024) {
//       setBottomPadding()
//     } else {
//       $('.text-feature-image .grid-x:last-of-type').css('padding-bottom', '')
//       $('.cta-block').css('padding-bottom', '')
//     }
//   }

//   // Run on DOM ready
//   $(window).on('load', maybeSetPadding)

//   // Run on resize (debounced)
//   let resizeTimeout
//   $(window).on('resize', function () {
//     clearTimeout(resizeTimeout)
//     resizeTimeout = setTimeout(maybeSetPadding, 50)
//   })
// })(jQuery)
